__turbopack_context__.v({
  "east": "PanoramaCompass-module-scss-module__nDai4q__east",
  "north": "PanoramaCompass-module-scss-module__nDai4q__north",
  "south": "PanoramaCompass-module-scss-module__nDai4q__south",
  "west": "PanoramaCompass-module-scss-module__nDai4q__west",
});
